module.exports = __webpack_public_path__ + "static/media/dining.6833d01b.png";